import { MAINNET_SIWA_DOMAIN } from "@decibeltrade/sdk";

import { env } from "@/env";

/**
 * The domain wallets sign in and derive their Aptos account under on this deployment.
 *
 * Pinned by `NEXT_PUBLIC_SIWA_DOMAIN` so every device signs the same value (the backend's
 * FRONTEND_DOMAIN check is strict equality), else the hostname. Mainnet on the server render,
 * where there is no hostname yet.
 */
export function siwaDomain(): string {
  if (env.NEXT_PUBLIC_SIWA_DOMAIN) return env.NEXT_PUBLIC_SIWA_DOMAIN;
  return typeof window === "undefined" ? MAINNET_SIWA_DOMAIN : window.location.hostname;
}
